export const textContainsHtmlTags = (text: string) => {
  return /<\/?[a-z][\s\S]*>/i.test(text)
}
